export const PhoneTypes = [
  { key: "office", value: "تلفن دفتر" }, // 1,
  { key: "mobile", value: "تلفن همراه" }, //2,
  { key: "home", value: "تلفن منزل" }, //3,
  { key: "other", value: "تلفن سایر" }, //4,
  { key: "officeFax", value: "دورنگار دفتر" }, //5,
  { key: "homeFax", value: "دورنگار منزل" }, //6,
  { key: "otherFax", value: "دورنگار سایر" }, //7,
];
